import { Box, Button } from "@mui/material";
import ActionButton from "@/components/Tablas/TableBase/ActionButton";
import { useMemo } from "react";
import { ICarrito } from "@/redux/models";
import { useTablaCarritoV2Props, ViewAs } from "../../logics/useTablaCarritoV2";
import { modalCarpetaType } from "../Modals";
import ChipAviso from "./ChipAviso";

const CarpetaActionButtons = ({ setModal, handleOpenRow, carpeta, viewAs }: { setModal: any, handleOpenRow: any, carpeta: ICarrito, viewAs: useTablaCarritoV2Props['viewAs'] }) => {

    const { PAGAR_CARPETA, FACTURAR_CARPETA, BORRAR_CARPETA, LIQUIDAR_CARPETA, NOTAS_CARPETA, VER_NOTAS_CARPETA } = modalCarpetaType;


    const memorizeVerInformes = useMemo(() => (
        viewAs === ViewAs.ADMIN ?
            <ActionButton
                title="Ver informes"
                onClick={() => handleOpenRow(carpeta.idCarrito)}
                icon="format_line_spacing"
            />
            :
            <Box display='flex' flexDirection='column' alignContent={'center'} alignItems={'center'} rowGap={1}>
                {carpeta?.observedReason != null && <ChipAviso onClick={() => setModal(VER_NOTAS_CARPETA, carpeta)} />}
                <Button
                    size="small"
                    variant='contained'
                    onClick={() => handleOpenRow(carpeta.idCarrito)}>
                    Ver informes
                </Button>
            </Box>

    ), [handleOpenRow])

    const memorizedModalButtons = useMemo(() => (
        <>
            <ActionButton
                title="Liquidar"
                onClick={() => setModal(LIQUIDAR_CARPETA, carpeta)}
                icon="receipt_long"
            />
            <ActionButton
                title="Pagado"
                onClick={() => setModal(PAGAR_CARPETA, carpeta)}
                icon="request_quote"
            />
            <ActionButton
                title="Factura"
                onClick={() => setModal(FACTURAR_CARPETA, carpeta)}
                icon="summarize"
            />
            <ActionButton
                title="Borrar"
                onClick={() => setModal(BORRAR_CARPETA, carpeta)}
                icon="highlight_off"
                sx={{ color: '#d32f2f' }}
            />


            <ActionButton
                title="Notas"
                onClick={() => setModal(NOTAS_CARPETA, carpeta)}
                icon="report_problem"
                sx={{ color: '#ff980e' }}
                hide={viewAs === ViewAs.USER}
            />
        </>
    ), [carpeta.pagado, carpeta.liquidado, carpeta.pdfLiquidacion, carpeta.estadoGeneral, carpeta.facturaAdjunta, carpeta.observed])


    return (
        <>
            {memorizeVerInformes}
            {viewAs === ViewAs.ADMIN && memorizedModalButtons}
        </>
    );
}

export default CarpetaActionButtons;